export default "__VITE_ASSET__BFlCq5aJ__"